import * as React from 'react';
import { makeStyles } from '@fluentui/react-components';
import { FOOTER_CONSTANTS } from '../constants/footerConstants';

const useStyles = makeStyles({
  footer: {
    textAlign: 'center',
    padding: '2rem 1rem',
    marginTop: '3rem',
  },
  container: {
    maxWidth: '900px',
    margin: '0 auto',
    padding: '1rem',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    width: 'fit-content',
    color: 'var(--primary-color)',
    fontSize: '0.9rem',
    fontWeight: '600',
  },
});

const Footer: React.FC = () => {
  const classes = useStyles();

  return (
    <footer className={classes.footer} aria-label={FOOTER_CONSTANTS.ARIA_LABEL}>
      <div className={classes.container}>
        <div>{FOOTER_CONSTANTS.COPYRIGHT_PREFIX} {new Date().getFullYear()} {FOOTER_CONSTANTS.COPYRIGHT_SUFFIX}</div>
      </div>
    </footer>
  );
};

export default Footer;